<!-- BModal.vue -->
<template>
  <div
    class="modal fade"
    :id="id"
    tabindex="-1"
    :aria-labelledby="`${id}Label`"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-fullscreen-sm-down modal-dialog-centered"
      :class="modalSizeClass"
    >
      <div class="modal-content">
        <div class="modal-header border-bottom pb-3">
          <h3 class="modal-title" :id="`${id}Label`">
            <slot name="title">{{ title }}</slot>
          </h3>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary" @click="handleOk">
              {{ okTitle }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, watch } from 'vue'
import Modal from 'bootstrap/js/dist/modal'

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  title: {
    type: String,
    default: 'Modal Title'
  },
  size: {
    type: String,
    default: 'medium',
    validator: (value) =>
      ['small', 'medium', 'large', 'extra-large'].includes(value)
  },
  okTitle: {
    type: String,
    default: 'OK'
  },
  visible: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['ok', 'update:visible'])

const modalSizeClass = computed(() => {
  switch (props.size) {
    case 'small':
      return 'modal-sm'
    case 'large':
      return 'modal-lg'
    case 'extra-large':
      return 'modal-xl'
    default:
      return ''
  }
})

let modalInstance = null

const handleOk = () => {
  emit('ok')
  modalInstance.hide()
}

onMounted(() => {
  modalInstance = new Modal(document.getElementById(props.id))

  watch(
    () => props.visible,
    (newValue) => {
      if (newValue) {
        modalInstance.show()
      } else {
        modalInstance.hide()
      }
    }
  )

  const modalElement = document.getElementById(props.id)
  modalElement.addEventListener('hidden.bs.modal', () => {
    emit('update:visible', false)
  })
})

onUnmounted(() => {
  if (modalInstance) {
    modalInstance.dispose()
  }
})
</script>
